import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { RankingPlayerList, MyInfo, PrizePoolList, QS, WsopNationalityRankingItem } from '../interface/leaderboard.interface';
import { ServiceBase } from './service.base';
import { DTO } from '../../../app/core/models/dto';

@Injectable({
    providedIn: 'root'
})
export class PromotionLeaderboardService extends ServiceBase {
    constructor(protected http: HttpClient) {
        super(http);
    }

    public getPromotionType(promotionId) {
        return this.getEndPoints<{ type: DTO.Enums.PromotionType }>(`/lapi/leaderboard/${promotionId}/detail`);
    }

    public getMyInfo(qs: QS, isPrizeHidden: boolean): Promise<MyInfo> {
        const params: { [key: string]: any } = {};
        if (!isPrizeHidden) {
            params.hasSummary = true;
        }
        if (qs.brandId) {
            params.brandId = qs.brandId;
        }
        if (qs.siteId) {
            params.siteId = qs.siteId;
        }

        return this.getEndPoints<MyInfo>(`/lapi/leaderboard/${qs.promotionId}/myinfo/${qs.nickname}`, params);
    }

    public getRankingPlayerList(qs: QS, limit: number = 10, isPrizeHidden: boolean): Promise<RankingPlayerList[]> {
        const url = `/lapi/leaderboard/${qs.promotionId}/${encodeURIComponent(qs.nickname || '')}`;
        const status = ['PENDING', 'OPTED_IN', 'COMPLETED', 'EXPIRED'];

        const params: { [key: string]: any } = {
            status
        };

        if (!!limit) {
            params.limit = Math.min(limit, 2500);
        }

        params.hasSummary = true;
        params.hasSummaryPaidPrizes = false;
        params.hasSummaryPrizeItem = false;

        if (isPrizeHidden) {
            params.forRank = true;
        }

        return this.getEndPoints<RankingPlayerList[]>(url, params, true);
    }

    public getWsopNationalityLeaderboard(optInGroupName: string, limit = 10): Promise<WsopNationalityRankingItem[]> {
        return this.getEndPoints<WsopNationalityRankingItem[]>(`/lapi/leaderboard/wsop/${optInGroupName}`, { limit }, true);
    }

    public getPrizePoolList(qs?: QS): Promise<PrizePoolList[]> {
        return this.getEndPoints<PrizePoolList[]>(`/lapi/leaderboard/${qs.promotionId}/prizes`);
    }

    public getPromotionGroup(groupId: any) {
        return this.getEndPoints<any>(`/lapi/leaderboard/groups/${groupId}`, null, true);
    }
}
